import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import BusComponent from '../BusComponent';
import IconMenu from '../iconMenu/IconMenu';
import { takeTourButtonEvents } from '../../enums/GoogleTagManagerEvents';
import googleTagManagerEvents from '../../helpers/GoogleTagManagerEventsWrapper';
import Mixpanel, { MIXPANEL_EVENTS } from '../../helpers/Mixpanel';
import AppConfig from '../../appConfig';

const TakeTourItem = googleTagManagerEvents('button', takeTourButtonEvents);

class HelpCenterButton extends BusComponent {
    handleKeyPress = (event, action) => {
        if (event.type === 'keypress') {
            if (event.key === ' ' || event.key === 'Enter') {
                // prevent the default action to stop scrolling when space is pressed
                event.preventDefault();
            } else {
                // user did not press space nor enter key, so we should do nothing
                return;
            }
        }
        action();
    };

    onClickIconMenu = open => {
        if (open) {
            Mixpanel.emitUserEvent(MIXPANEL_EVENTS.SUPPORT_OPEN);
        }
    };

    onTourClick = event => {
        this.handleKeyPress(event, () => {
            this.emit('TOGGLE_MAP_LAYERS_PANEL', { isVisible: false, source: 'user' });
            this.emit('HELP_TOUR_START_REQUEST');
            this.emit('CLOSE_DROPDOWN');
            Mixpanel.emitUserEvent(MIXPANEL_EVENTS.TAKE_TOUR);
        });
    };

    onSendFeedbackClick = event => {
        this.handleKeyPress(event, () => {
            this.emit('FEEDBACK_POPUP_REQUEST');
            this.emit('CLOSE_DROPDOWN');
            Mixpanel.emitUserEvent(MIXPANEL_EVENTS.TRIGGER_FEEDBACK_MODAL);
        });
    };

    onHelpCenterClick = event => {
        this.handleKeyPress(event, () => {
            this.emit('CLOSE_DROPDOWN');
            window.open(AppConfig.constants.helpCenterBaseLink, '_blank');
            Mixpanel.emitUserEvent(MIXPANEL_EVENTS.TRIGGER_KNOWLEDGE_BASE);
        });
    };

    render() {
        const { isApplicationInViewMode, userInfo, intl } = this.props;

        return (
            <IconMenu
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                targetOrigin={{ vertical: 'top', horizontal: 'right' }}
                icon="help"
                iconClassName="material-symbols"
                className="application-header__popup-wrapper"
                tabIndex="0"
                tooltip={intl.formatMessage({ id: 'helpCenter' })}
                triggerClassName="application-header__button icon-dark"
                ariaLabel={intl.formatMessage({ id: 'helpCenter' })}
                marginTop={-5}
                marginLeft={10}
                onClick={this.onClickIconMenu}
            >
                <div className="material-menu">
                    <TakeTourItem className="material-menu__item" onClick={this.onTourClick}>
                        <FormattedMessage id="header.takeATour" />
                    </TakeTourItem>

                    <button className="material-menu__item" onClick={this.onHelpCenterClick}>
                        <FormattedMessage id="helpCenter" />
                    </button>

                    {!isApplicationInViewMode && userInfo.userId !== -1 && (
                        <div>
                            <button
                                className="material-menu__item"
                                onClick={this.onSendFeedbackClick}
                            >
                                <FormattedMessage id="sendFeedback" />
                            </button>
                        </div>
                    )}
                </div>
            </IconMenu>
        );
    }
}

HelpCenterButton.propTypes = {
    intl: PropTypes.object.isRequired,
    isApplicationInViewMode: PropTypes.bool,
    userInfo: PropTypes.object.isRequired,
};

HelpCenterButton.defaultProps = {
    isApplicationInViewMode: false,
};

export default injectIntl(HelpCenterButton);
